import styled from 'styled-components';
import { colors } from 'Constants/Colors';

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 35vh;
  width: 20vw;
  background: ${colors.WHITE};
  border-radius: 1rem;
  padding-top: 1rem;
  text-decoration: none;
`;

export const DateInfo = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 25%;
  gap: 1rem;
  align-items: center;
  padding-left: 0.75rem;
`;

export const DayInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DetailContainer = styled.div`
  height: 70%;
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  flex-direction: column;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
`;

export const LocationInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
`;

export const TimeInfo = styled.div`
  display: flex;
  flex-direction: row;
  padding-left: 0.2rem;
  padding-top: 0.3rem;
`;

export const CapacityContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.25rem;
`;

export const AttendanceContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const ImageIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 2rem;
  max-height: 2rem;
  position: relative;
`;

export const dayNumber = {
  fontFamily: 'metropolis',
  fontSize: '2.5vmax',
  fontWeight: 'bold',
  color: colors.BLACK,
};

export const dayText = {
  fontFamily: 'metropolis',
  fontSize: '1vmax',
  fontWeight: 'bold',
  color: colors.BLACK,
};

export const monthText = {
  fontFamily: 'metropolis',
  fontSize: '1vmax',
  fontWeight: 'bold',
  color: colors.GRAY,
};

export const addressText = {
  fontFamily: 'metropolis',
  fontSize: '1.5vmin',
  fontWeight: 'bold',
  color: colors.GRAY_DARKER,
  wordBreak: 'break-word',
  paddingLeft: '0.3rem',
};

export const timeText = {
  fontFamily: 'metropolis',
  fontSize: '1vmax',
  color: colors.GRAY,
};

export const capacityText = {
  fontFamily: 'metropolis',
  fontSize: '1vmax',
  color: colors.GRAY,
};

export const gpsIcon = {
  color: colors.GRAY,
};

export const Icon = {
  width: '1.6rem',
  height: '1.6rem',
};

export default {
  CardContainer,
  DateInfo,
  DayInfo,
  DetailContainer,
  LocationInfo,
  TimeInfo,
  CapacityContainer,
  ImageIconContainer,
  dayNumber,
  dayText,
  monthText,
  addressText,
  timeText,
  capacityText,
  gpsIcon,
  Icon,
};
